import { Component, Inject, Injector, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AbstractComponent, CountryModel, Customer, CustomerService } from 'lib-trend-core';
import { Validators } from 'ngx-editor';

@Component({
    selector: 'app-customer-quick-form',
    templateUrl: './customer-quick-form.component.html',
    styleUrls: ['./customer-quick-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CustomerQuickFormComponent extends AbstractComponent {
  public customer: Customer;


  constructor(
    injector: Injector,
    public dialogRef: MatDialogRef<CustomerQuickFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Customer,
    private customerService: CustomerService,
  ) {
    super(injector);
    this.setupForm();
  }

  private setupForm(): void {
    this.formGroup = this.formBuilder.group({
      name: [null, [Validators.required]],
      phone: [null, [Validators.required]],
      email: [null],
    });
  }

  save(): void {
    if (this.formGroup.invalid) {
      this.formGroup.markAllAsTouched();
      return;
    }

    this.customer = this.formGroup.value;

    const dataToSave: Customer = { ...this.customer, company: super.getCompanyCurrentUser(), };

    this.customerService.create(dataToSave).pipe()
      .subscribe((customer: Customer) => {
        this.alertService.success(this.t('kanban.customerQuickForm.createSuccess'));
        this.dialogRef.close(customer);
      });
  }

  close(): void {
    this.dialogRef.close();
  }
}
